import AccordionItem from '../../molecules/AccordionItem';
import React, { Component, Fragment } from 'react';
import SectionHeading from '../../molecules/SectionHeading';
import './styles.css';

/**
 * A template for the contact us section.
 *
 * @typedef {Object} Props
 * @prop {Object} content
 *
 * @augments {Component<Props>}
 */

export default class Faq extends Component {

	render () {
		const { questions, heading } = this.props.content.faq;
		const { title, subTitle } = heading;
		return (
			<Fragment>
				<div className='faqPadded'>
					<SectionHeading heading={title} subheading={subTitle} />
					{questions.map(({ question, answer }, index) => (
						<AccordionItem
							// eslint-disable-next-line react/no-array-index-key
							key={index}
							question={question}
							answer={answer}
						/>
					))}
				</div>
			</Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/templates/Faq/Faq.js